import { useCallback } from 'react';

import useAuthSelectors from 'modules/Auth/AuthProvider/useAuthSelector';
import { HintStatusFeature } from 'services/hint-status/queries/useHintStatus/useHintStatus.interface';

export default function usePersistData<T>() {
    const { user } = useAuthSelectors('user');

    const setData = useCallback(
        (key: HintStatusFeature | string, value: T) => {
            localStorage.setItem(`${user?.pk}.${key}`, JSON.stringify(value));
        },
        [user?.pk]
    );

    const getData = useCallback(
        (key: HintStatusFeature | string): T => {
            const data = localStorage.getItem(`${user?.pk}.${key}`);

            return data ? JSON.parse(data) : null;
        },
        [user?.pk]
    );

    return {
        setData,
        getData,
    };
}
